import { useEffect, useRef } from 'react';

/**
 * Custom hook for initializing Supademo with optional user variables
 * @param {Object} variables - Optional user variables (email, name, etc.)
 * @returns {React.RefObject} - Ref object to attach to the target element
 */
export const useSupademo = (variables = {}) => {
	const elementRef = useRef(null);
	const initializedRef = useRef(false);

	// Hardcoded API key since it never changes
	const API_KEY = '7029763fef4591c544b8b27758bfd5f4a6762545447a65feec33d9b66e0cf036';

	useEffect(() => {
		if (elementRef.current && window.Supademo && !initializedRef.current) {
			console.log('LOADING SUPADEMO');
			window.Supademo(API_KEY, {
				variables: {
					email: '', // optional user email
					name: '', // optional user name
					...variables, // spread any additional variables
				},
			});
			initializedRef.current = true;
		}
	}, [variables]);

	return elementRef;
};
